import { useState } from "react";
import { KanbanBoard } from "@/components/pipeline/KanbanBoard";
import { AddProspectDialog } from "@/components/prospects/AddProspectDialog";
import { EditProspectDialog } from "@/components/prospects/EditProspectDialog";
import { PageTitle } from "@/components/common/PageTitle";
import { useProspects, type Prospect } from "@/hooks/useProspects";

export function Pipeline() {
  const { isLoading } = useProspects();
  const [editingProspect, setEditingProspect] = useState<Prospect | null>(null);

  const handleEditProspect = (prospect: Prospect) => {
    setEditingProspect(prospect);
  };

  const handleDeleteProspect = () => {
    // We'll pass the prospect ID to get the full prospect object
    // This will be handled by the KanbanBoard component
  };

  if (isLoading) {
    return (
      <div className="space-y-6">
        <PageTitle title="Pipeline" />
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold tracking-tight">Pipeline</h1>
        </div>
        <div className="flex items-center justify-center py-12">
          <p className="text-muted-foreground">Loading pipeline...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 h-full">
      <PageTitle title="Pipeline" />
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-tight">Pipeline</h1>
        <AddProspectDialog />
      </div>

      <div className="flex-1 min-h-0">
        <KanbanBoard
          onEditProspect={handleEditProspect}
          onDeleteProspect={handleDeleteProspect}
        />
      </div>

      {/* Edit Dialog */}
      {editingProspect && (
        <EditProspectDialog
          prospect={editingProspect}
          trigger={<div />} // Hidden trigger since we're controlling the dialog state
        />
      )}
    </div>
  );
}